import { fieldmateInstallationUrl } from "../../utils/installationCode";

export interface InstallationCodeLinkProps {
  code?: string | null;
  // Texte quand le site n'est pas relié (« — » dans un tableau).
  emptyLabel?: string;
}

// Le code d'installation, avec un lien vers l'installation dans FieldMate quand
// REACT_APP_FIELDMATE_URL est configurée. Le clic ne doit pas ouvrir la ligne
// du tableau qui le contient.
export default function InstallationCodeLink({ code, emptyLabel = "Non relié" }: InstallationCodeLinkProps) {
  if (!code) return <>{emptyLabel}</>;
  const url = fieldmateInstallationUrl(code);
  if (!url) return <>{code}</>;
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      title="Ouvrir l'installation dans FieldMate"
      onClick={(e) => e.stopPropagation()}
    >
      {code}
    </a>
  );
}
